import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getToken = () => localStorage.getItem("bnm_customer_token");
export const setToken = (t) => localStorage.setItem("bnm_customer_token", t);
export const clearToken = () => localStorage.removeItem("bnm_customer_token");

export const authHeaders = () => ({ Authorization: `Bearer ${getToken()}` });

export const api = axios.create({ baseURL: API });

export function money(amount, currency) {
  const c = (currency || "usd").toUpperCase();
  return c === "USD" ? `$${amount}` : `${c} ${amount}`;
}

export function formatApiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").filter(Boolean).join(" ");
  return String(detail);
}
